export const ChatbotCookiePrefix: string = 'OTAChatBot'

export const OTATokenCookie: string = 'apollo-token'
export const OTATokenExpiryCookie: string = 'apollo-expiry'
export const ChatIdCookie: string = `${ChatbotCookiePrefix}-chatId`
export const ChatNextLocale: string = `NEXT_LOCALE`
export const OTALocale: string = `ota-locale`
export const OTATestVariant: string = `ota-test`
